import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div>

  <footer id="footer">
    <div class="container">
      <div class="credits">
        Designed/Developed by Taha Sheikh
      </div>
    </div>
  </footer>

    </div>
  )
}

export default Footer